import React, { FunctionComponent, ReactNode } from 'react';
import { ParentPage, SanityNavLink } from '../../types/common';
import Breadcrumb from '../Breadcrumb';
import PageHeaderLinks from '../PageHeaderLinks';
import RichText from '../RichText';
import './styles.scss';
import cognitoService from "../../services/cognitoService";
import { navigate } from "gatsby";
import { setUser } from "../../services/user";
import { InternalLinkIcon } from '../Icons';


type HeroProps = {
  title: string;
  description?: any;
  breadcrumb: ParentPage;
  links?: SanityNavLink[];
  logout?: boolean;
  searchBar?: ReactNode;
}

function verifyTextSize(text: string, limit = 48): boolean {
  return text.length > limit;
}


const handleLogout = async () => {
  await cognitoService.signOut();
  setUser({});
  await navigate("/login");
}


const Hero: FunctionComponent<HeroProps> = ({ title, description, breadcrumb, links, searchBar, logout }) => {
  return (
    <section className='hero'>
      <div className='wrapper'>
        <Breadcrumb data={breadcrumb} />
        <div className='hero-content'>
          <div>
            <div className='hero-texts'>
              <h1 className={verifyTextSize(title) ? 'small' : ''}>{title}</h1>
              {description && (
                <RichText value={description} />
              )}
            </div>
            {links && (
              <PageHeaderLinks
                links={links}
              />
            )}
            {logout && (
              <div className='links-list'>
                <button onClick={() => handleLogout()}>
                  Logout
                  <InternalLinkIcon />
                </button>
              </div>
            )}
          </div>
          {searchBar}
        </div>
      </div>
    </section>
  );
}

export default Hero;
